/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type { ListUserTypesQueryResponse } from '../types/ListUserTypes'

function getListUserTypesUrl() {
  const res = { method: 'GET', url: `/api/v1/users/user-types/` as const }
  return res
}

/**
 * @description API endpoint for listing available user types.
 * Architecture: READ operation - returns the list of valid user type names.
 * Only Admin users with manage_user_types permission can access this endpoint.
 * @summary List assignable user types
 * {@link /api/v1/users/user-types/}
 */
export async function listUserTypes(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListUserTypesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListUserTypesUrl().url.toString(),
    ...requestConfig,
  })
  return res.data
}
